// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"7bae7725","534":"02563f20","609":"2e505c4e","787":"cda612ba","994":"cc0ceaf4"}[chunkId] + ".chunk.js";
};